var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 h-100",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "w-100 video-container-position"
  }, [_c('youtube', {
    ref: _vm.youtubeID,
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "fitParent": true,
      "resize": true,
      "video-id": _vm.youtubeID,
      "player-vars": _vm.options
    },
    on: {
      "playing": _vm.youTubeVideoPlaying,
      "paused": _vm.youTubeVideoPaused,
      "ended": _vm.youtubeVideoEnded,
      "error": _vm.youtubeVideoError,
      "ready": _vm.youtubeVideoReady
    }
  })], 1), _vm.isVideoLoadingOrInError ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center w-100 h-100 mb-2 status-container video-container-position"
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-column justify-content-center align-items-center"
  }, [_vm.hasValidVideoID && _vm.isNotReady ? _c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": _vm.primaryWhiteColor,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.videoLoadingOrErrorStatus) + " ")], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }